import { Stack, Typography } from '@mui/material';
import { Conversation } from 'src/graphql';
import { SuggestionRow } from './suggestion-row';
import { MergeSuggestionGroup } from './suggestions.types';

interface SuggestionGroupProps {
  group: MergeSuggestionGroup;
  getStatusLabel: (statusId: string) => string;
  onSelect: (conversation: Conversation) => void;
}

export const SuggestionGroup = ({ group, getStatusLabel, onSelect }: SuggestionGroupProps) => {
  if (!group.rows.length) {
    return null;
  }

  return (
    <Stack gap={0.75}>
      <Typography variant="caption" fontWeight={600} color="text.secondary">
        {group.label}
      </Typography>
      <Stack gap={1}>
        {group.rows.map((row) => (
          <SuggestionRow
            key={row.conversation.id}
            suggestion={row}
            statusLabel={getStatusLabel(row.statusId)}
            onSelect={onSelect}
          />
        ))}
      </Stack>
    </Stack>
  );
};
